<template>
	<AIInfoCard v-if="currentState === StateEnum.information"></AIInfoCard>

	<v-card v-else-if="currentState === StateEnum.inProgress" class="d-flex align-center">
		<div class="h-min">
			<v-card-title class="headline h-auto" primary-title> AI is working </v-card-title>
			<v-card-text class="h-auto">
				This action may take some time. Please, wait...
				<v-progress-linear :indeterminate="true"></v-progress-linear>
			</v-card-text>
		</div>
	</v-card>

	<div v-else>
		<block-video-viewer :value="block" :key="block.data.video._file" />
	</div>
</template>
<script>
import AIInfoCard from '../_components/placeholders/AIInfoCard.vue';
import BlockVideoViewer from './BlockVideoViewer.vue';
import AIService, { aiActionsStatus } from '../../../../services/AIService';
import { PFile } from 'plant-common/src/models/pFile';

export default {
	name: 'BlockAIAvailable',
	props: ['block'],
	inject: ['lessonPlanController'],
	components: { BlockVideoViewer, AIInfoCard },
	data() {
		return {
			aiService: null,
			interval: null,
			job: null,
			StateEnum: Object.freeze({
				information: 'information',
				inProgress: 'inProgress',
				videoLoaded: 'videoLoaded'
			})
		};
	},
	computed: {
		currentState() {
			if (this.isInProgressState) {
				return this.StateEnum.inProgress;
			}
			if (this.isInformationState) {
				return this.StateEnum.information;
			}
			return this.StateEnum.videoLoaded;
		},
		isInformationState() {
			return !this.block.data.video && !this.block.data.avatarJobId;
		},
		isInProgressState() {
			return !this.block.data.video && this.block.data.avatarJobId;
		}
	},
	async created() {
		if (this.$store.state.user) {
			this.aiService = new AIService(this.$store.state.user.token);
		}

		await this.$checkPendingJobs();
	},
	watch: {
		'block.data.avatarJobId': {
			async handler(jobId) {
				if (!jobId) return;

				await this.pollJob();
			}
		}
	},
	methods: {
		async $checkPendingJobs() {
			if (this.lessonPlanController.mode !== 'edit') return;

			const notHasToPollJob = this.block.data.video || !this.block.data.avatarJobId;
			if (notHasToPollJob) return;

			await this.pollJob();
		},
		async $updateJobInformation() {
			this.job = await this.aiService.getJobBy(this.block.data.avatarJobId);
		},
		$isJobCompleted() {
			return this.job.status === aiActionsStatus.COMPLETE;
		},
		$isJobFailed() {
			return this.job.status === aiActionsStatus.FAILED;
		},
		$setInformationState() {
			this.block.data.avatarJobId = '';
		},
		getFilenameFrom(url) {
			return url.split('/').pop();
		},
		async downloadFileFromUrl(url, filename) {
			const fileData = await this.aiService.getFileBy(url);

			const blob = new Blob([new Uint8Array(fileData.data)], { type: 'video/mp4' });

			return new File([blob], filename, { type: blob.type });
		},
		async setVideo() {
			const file = await this.downloadFileFromUrl(
				this.job.response.videoUrl,
				this.getFilenameFrom(this.job.response.videoUrl)
			);
			const newFile = new PFile(file);
			await newFile.upload();

			this.block.data.video = newFile;
		},
		async pollJob() {
			this.interval = setInterval(async () => {
				await this.$updateJobInformation();
				if (this.$isJobCompleted()) {
					clearInterval(this.interval);
					await this.setVideo();
				} else if (this.$isJobFailed()) {
					this.lessonPlanController.showNotification('Video generation failed');
					this.$setInformationState();
					clearInterval(this.interval);
				}
			}, 2000);
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	}
};
</script>
<style scoped>
.h-auto {
	height: auto;
}

.h-min {
	height: min-content;
}
</style>
